export default __webpack_public_path__ + "static/media/tsu.42bec93a.jpg";